export default {
  savePosition(state, position) {
    state.position = position
  },
  resetPosition(state) {
    state.position = { left: 0, top: 0 }
  }
}
